import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorDetail, DataMinerUiError } from './error-detail.model';
import { ErrorManagerService } from './error-manager.service';
import { Subject } from 'rxjs';

@Injectable()
export class ErrorManagerServiceImpl implements ErrorManagerService {
    public lastErrorDetail: ErrorDetail;
    public dataMinerUiError: DataMinerUiError;
    public errorFeedsListKey = 'feeds_list';
    public errorExploreDataSetKey = 'explore_data_set';
    public errorCurrentParrentKey;
    public dataMinerUiErrors = { 'feeds_list': [], 'explore_data_set': [] };
    private dataMinerUiErrorsSubject: Subject<any> = new Subject<any>();
    public dataMinerUiErrorsObservable = this.dataMinerUiErrorsSubject.asObservable();

    constructor(private router: Router) { }

    public handleNotFound(location: string, message: string, activityId?: string, timestamp?: string, detailMessage?: string) {
        const errorDetail = new DataMinerUiError();
        errorDetail.activityId = activityId;
        errorDetail.code = location;
        errorDetail.message = message;
        errorDetail.timestamp = timestamp;
        errorDetail.detailedMessage = detailMessage;
        this.router.navigate(['/404']);
    }

    public handleError(error: Error, title: string, location: string, message: string, activityId?: string, timestamp?: string): boolean {
        if (error['status'] === 404) {
            this.handleNotFound(location, message, activityId, timestamp);
            return true;
        }

        const errorDetail = new DataMinerUiError();
        errorDetail.activityId = activityId;
        errorDetail.code = location;
        errorDetail.message = message;
        errorDetail.timestamp = timestamp;

        return true;
    }

    public removeDataMinerUiError(errorParentKey: string, errorKey: string) {
        switch (errorParentKey) {
            case this.errorFeedsListKey: {
                if (errorKey !== 'feed-list') {
                    const index = this.dataMinerUiErrors.feeds_list.findIndex(ele => ele.key === errorKey);
                    if (index > -1 ) {
                        this.dataMinerUiErrors.feeds_list.splice(index);
                    }
                } else if (this.dataMinerUiErrors.feeds_list.length > 0) {
                    this.dataMinerUiErrors.feeds_list = [];
                }
                break;
            }
            case this.errorExploreDataSetKey: {
                if (errorKey !== 'feed-grid') {
                    const index = this.dataMinerUiErrors.explore_data_set.findIndex(ele => ele.key === errorKey);
                    if (index > -1 ) {
                        this.dataMinerUiErrors.explore_data_set.splice(index);
                    }
                } else if (this.dataMinerUiErrors.explore_data_set.length > 0) {
                    this.dataMinerUiErrors.explore_data_set = [];
                }
                break;
            }
        }

        return true;
    }

    private getDataMinerUiError(error: any, message: string): DataMinerUiError {
        const dataMinerError = new DataMinerUiError();
        dataMinerError.message = message;
        dataMinerError.detailedMessage = message;

        try {
            const err = error.json();
            if (err && err.activityId && err.code) {
                let messageText = '';

                if (err.code && err.code.indexOf('API_') == -1 && err.code.indexOf('HOST_') == -1 && err.code.indexOf('CMN_') == -1) {
                    messageText = `${err.code}. `;
                }

                if (err.message) {
                    messageText += err.message;
                }

                dataMinerError.message = messageText;
                dataMinerError.detailedMessage = err.detailedMessage ? err.detailedMessage : messageText;
            }
        } catch (Exception) { }

        return dataMinerError;
    }

    private setDataMinerUiErrors(errorParentKey: string, errorKey: string, error: DataMinerUiError): void {
        const errorjson = { 'key': errorKey, 'error': error};
        this.errorCurrentParrentKey = errorParentKey;

        switch (errorParentKey) {
            case this.errorFeedsListKey: {
                let notFound = true;
                this.dataMinerUiErrors.feeds_list.forEach(ele => {
                    if (ele.key === errorKey) {
                        notFound = false;
                        return;
                    }
                });

                if (notFound) {
                    this.dataMinerUiErrors.feeds_list.push(Object.assign({}, errorjson));
                }

                break;
            }
            case this.errorExploreDataSetKey: {
                let notFound = true;
                this.dataMinerUiErrors.explore_data_set.forEach(ele => {
                    if (ele.key === errorKey) {
                        notFound = false;
                        return;
                    }
                });

                if (notFound) {
                    this.dataMinerUiErrors.explore_data_set.push(Object.assign({}, errorjson));
                }

                break;
            }
        }
    }

    public saveDataMinerUiError(errorParentKey: string, errorKey: string, error: any, message: string): boolean {
        this.dataMinerUiError = this.getDataMinerUiError(error, message);
        this.setDataMinerUiErrors(errorParentKey, errorKey, this.dataMinerUiError);
        this.dataMinerUiErrorsSubject.next(this.dataMinerUiErrors[errorParentKey]);
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/error-handling/error-manager-impl.service.ts